import React, {useState} from 'react';
import Spinner from '../../reusables/spinner';
import InputField from '../../reusables/input';
import {connect} from 'react-redux';
import {update_next_of_kin} from '../../../redux/actions/adminActions';

function NextOfKin({
    updateNok,
    user,
    newUser,
    submit,
    next,
    accessToken,
    unapproved,
    prev,
    close
}) {

    const [prevData,
        setPrevData] = useState(user)

    const [formData,
        setData] = useState({
        next_of_kin_name: prevData
            ?.next_of_kin_name,
        next_of_kin_phone: prevData
            ?.next_of_kin_phone,
        next_of_kin_address: prevData
            ?.next_of_kin_address
    })

    const [isLoading,
        setIsLoading] = useState(false);

    const handleLoading = () => {
        setIsLoading(true);

        setInterval(() => {
            setIsLoading(false)
        }, 4000)
    }

    const handleChange = (e) => {

        if (!newUser) {
            setPrevData({
                ...prevData,
                [e.target.name]: e.target.value
            })
        }

        setData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLoading();
        if (newUser) {
            submit(formData);
            next();
        } else {
            updateNok(user
                ?.id, formData, unapproved ? 'unapproved' : 'approved',  accessToken, close);
        }
    }

    return (
        <div className='sectionHeight--mid container py-3'>
            <form className='px-2' onSubmit={handleSubmit}>
                <div className="mt-2 mb-2">
                    <InputField
                        label="Name"
                        name='next_of_kin_name'
                        value={formData.next_of_kin_name}
                        onChange={handleChange}/>
                </div>

                <div className="mt-2 mb-2">
                    <InputField
                        label="Phone number"
                        name='next_of_kin_phone'
                        value={formData.next_of_kin_phone}
                        onChange={handleChange}/>
                </div>

                <div className="mt-2 mb-2">
                    <InputField
                        label="Home/Office Address"
                        name='next_of_kin_address'
                        value={formData.next_of_kin_address}
                        onChange={handleChange}/>
                 </div>

                <div className="mt-4">
                    {newUser
                        ? <div className='py-3'>
                                <button className="btn__filled textIsBold">Continue</button>
                            </div>
                        : isLoading
                            ? <button className="btn__filled textIsBold alignOnly" disabled>Please Wait {' '}
                                    <Spinner/>
                                </button>
                            : <button className="btn__filled textIsBold" onClick={handleSubmit}>Save Changes</button>
}
                </div>
            </form>
        </div>

    )
}

const mapStateToProps = (state) => ({accessToken: state.admin.token})

const mapDispatchToProps = (dispatch) => ({
    updateNok: (id, data, status, token, success) => dispatch(update_next_of_kin(id, data, status, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(NextOfKin)
